"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const rsuite_1 = require("rsuite");
const react_redux_1 = require("react-redux");
const state_1 = require("@airstudio/state");
const JsonViewer_1 = require("../JsonViewer");
exports.UserEditor = ({ isVisible, setIsVisible, hide, componentClass: CC }) => {
    const user = react_redux_1.useSelector(state_1.Selectors.Me.get);
    const { isProcessing, errorMessage } = react_redux_1.useSelector(state_1.Selectors.Me.state);
    const dispatchUpdateMe = state_1.Operations.Me.update(react_redux_1.useDispatch());
    const handleSave = async () => {
        const isSuccessful = await dispatchUpdateMe(user);
        if (isSuccessful) {
            setIsVisible(false);
            rsuite_1.Notification.success({ title: 'Workspace updated' });
        }
    };
    const isChildVisible = (key) => {
        if (hide && (hide.includes(key) || hide.includes('all'))) {
            return false;
        }
        return true;
    };
    return (react_1.default.createElement(rsuite_1.Modal, { size: "md", show: isVisible, onHide: () => setIsVisible(false) },
        isChildVisible('header') && (react_1.default.createElement(rsuite_1.Modal.Header, null,
            react_1.default.createElement(rsuite_1.Modal.Title, { style: { textAlign: 'center' } }, "Your profile"))),
        react_1.default.createElement(rsuite_1.Modal.Body, null,
            errorMessage && isChildVisible('errorMessage') &&
                react_1.default.createElement(rsuite_1.Message, { description: errorMessage }),
            CC
                ? (react_1.default.createElement(CC, { user: user, errorMessage: errorMessage, isProcessing: isProcessing, handleSave: handleSave }))
                : react_1.default.createElement(JsonViewer_1.JsonViewer, { json: { user } })),
        isChildVisible('footer') && (react_1.default.createElement(rsuite_1.Modal.Footer, null,
            react_1.default.createElement(rsuite_1.Button, { appearance: "primary", loading: isProcessing, onClick: () => handleSave() }, "Save")))));
};
//# sourceMappingURL=index.js.map